import styled from "@emotion/styled"
import { Box } from "@mui/material"
import "swiper/css"
import "swiper/css/navigation"
import { mediaQueries } from "ui"
import SwiperOnMobile from "ui/SwiperOnMobile/SwiperOnMobile"
import { transformProperties } from "utils/simplifyData"
import CardBoxIconContent from "../common/CardBoxIconContent"

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 188px;

  ${mediaQueries.mobile} {
    width: 100%;
  }

  ${mediaQueries.tablet} {
    width: 100%;
  }
  ${mediaQueries.desktopM} {
    max-width: 365px;
    width: calc(22% - 32px);
  }
  ${mediaQueries.desktop} {
    width: calc(22% - 32px);
  }
`

const ProductCarInsuranceBoxesContent = ({ itemsList, onItemClick }: any) => {
  if (!itemsList || !itemsList.blocks || itemsList.blocks.length === 0) {
    return null
  }

  return (
    <SwiperOnMobile
      swiperProps={{
        spaceBetween: 40,
        slidesPerView: 1,
        centeredSlides: false,
      }}
    >
      {itemsList?.blocks?.map((item: any, index: number) => {
        const { icon, title, text } = transformProperties(item?.properties)

        return (
          <StyledBox key={`ProductCarInsuranceBoxesContent-StyledBox-${index}`}>
            <CardBoxIconContent
              title={title}
              text={text}
              icon={icon}
              onClick={() => onItemClick(title.value)}
            />
          </StyledBox>
        )
      })}
    </SwiperOnMobile>
  )
}

export default ProductCarInsuranceBoxesContent
